import React from 'react';
import { Basket } from 'src/assets/images';
import TealiumEvents from 'src/helpers/tealium-events';
import './basket-button.scss';

export default function BasketButton(props) {
  return (
    <div
      className={`basket-button columns is-desktop is-vcentered ${
        props.isMobile ? 'mobile-design' : ''
      }`}
      onClick={() => {
        props.showBasket(true);
        TealiumEvents.openCart(props.customerType);
      }}
    >
      <img src={Basket} className="basket-image" />
      {!props.isMobile && 'My Basket'}
    </div>
  );
}
